namespace TabAurous.OMS {
    export interface MoldMasterRow {
        MoldId?: number;
        Code?: string;
        Name?: string;
        RackNo?: string;
    }

    export namespace MoldMasterRow {
        export const idProperty = 'MoldId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.MoldMaster';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            MoldId = "MoldId",
            Code = "Code",
            Name = "Name",
            RackNo = "RackNo"
        }
    }
}
